import Icon1 from "@assets/icons/Icon";
import BaseModal from "@components/modals/BaseModal";
import Button from "@components/ui/buttons/Button";

interface PDFViewerModalProps {
  pdfUrl: string;
  title?: string;
  onClose: () => void;
}

export function PDFViewerModal({
  pdfUrl,
  title = "Document PDF",
  onClose,
}: PDFViewerModalProps) {
  return (
    <BaseModal
      title={title}
      startIcon={<Icon1 name="pdf" size={20} />}
      onClose={onClose}
      display="centered"
      width="max-w-4xl"
    >
      <div className="flex flex-col">
        <div className="overflow-hidden" style={{ height: "70vh" }}>
          <iframe
            src={pdfUrl}
            className="w-full h-full"
            title={title}
          />
        </div>
        <div className="border-t-1 p-4 flex flex-row justify-end gap-2">
          <Button
            variant="small"
            label="Télécharger"
            onClick={() => window.open(pdfUrl, "_blank")}
          />
        </div>
      </div>
    </BaseModal>
  );
}
